import { render, staticRenderFns } from "./NewPromoCode.vue?vue&type=template&id=6c92c93c&"
import script from "./NewPromoCode.vue?vue&type=script&lang=js&"
export * from "./NewPromoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports